import * as z from "zod";

export const EntityGroupSchema = z.object({
  id: z.number().optional(),
  title: z.string().optional(),
  color: z.string().optional()
});

export const EntitiesInGroupModelSchema = z.object({
  uwis: z.record(z.string(), z.string()).optional().default({}),
  group: EntityGroupSchema.optional()
});

export const EntitiesOnMapResponseSchema = z.record(
  z.string(),
  EntitiesInGroupModelSchema
);

export type EntitiesInGroupModelSchemaType = z.infer<typeof EntitiesInGroupModelSchema>;
export type EntitiesOnMapResponseType = z.infer<typeof EntitiesOnMapResponseSchema>;
